import { AssetEntity } from '@hellodarwin/core/lib/features/entities';
import { useAppDispatch } from '../../../app/app-hooks';
import { downloadAsset } from '../../../features/api/slices/assets-slice';
import { useNewClientApi } from '../../../features/api/use-client-api';
import SimpleFilesList from './simple-files-list';

interface GamePlanFilesListProps {
  gamePlans: AssetEntity[];
}

const GamePlanFilesList = ({ gamePlans }: GamePlanFilesListProps) => {
  const dispatch = useAppDispatch();
  const api = useNewClientApi();

  const handleDownload = async (asset: AssetEntity) => {
    try {
      const url = (
        await dispatch(
          downloadAsset({ api, asset_id: asset.asset_id }),
        ).unwrap()
      ).link;

      window.open(url, 'download');
    } catch (error) {
      console.error(error);
    }
  };

  return <SimpleFilesList handleDownload={handleDownload} assets={gamePlans} />;
};

export default GamePlanFilesList;
